import { Suspense } from 'react';
import { Await } from 'react-router';
import { LocationStoreProvider } from 'src/components/tabs/location-store-context';
import { Region } from '@/components/region';
import { readPageLocationName } from '@/lib/page-location';
import type { LocationPageRouteData } from './types';

function Skeleton() {
    return (
        <div className="gap-8 bg-sand-95 lg:grid lg:grid-cols-12 pb-8 lg:pb-20">
            <div className="h-10 w-full max-w-md rounded-full bg-muted lg:col-span-10 lg:col-start-2" />
            <div className="h-64 rounded-lg bg-muted lg:col-span-10 lg:col-start-2" />
            <div className="h-64 rounded-lg bg-muted lg:col-span-10 lg:col-start-2" />
        </div>
    );
}

export function LocationPageRoute({ data }: { data: LocationPageRouteData }) {
    const locationName = readPageLocationName(data.page) ?? null;
    const parentLocationLabel = data.parentLocationLabel ?? null;

    return (
        <>
            <Suspense fallback={<Skeleton />}>
                {/* Pass the loader promise as-is: a promise created during render (e.g. Promise.all) is a new,
                    untracked promise on every transition retry, so <Await> would suspend forever and the
                    previous location page would stay on screen after a client navigation. */}
                <Await resolve={data.storeBundle}>
                    {({ store, restaurantAnalyticsName, storeAnalyticsName }) => (
                        <LocationStoreProvider
                            store={store}
                            locationName={locationName}
                            parentLocationLabel={parentLocationLabel}
                            restaurantAnalyticsName={restaurantAnalyticsName ?? null}
                            storeAnalyticsName={storeAnalyticsName ?? null}>
                            {data.page.regions?.map((region) => (
                                <Region key={`${data.page.id}:${region.id}`} page={data.page} regionId={region.id} />
                            ))}
                        </LocationStoreProvider>
                    )}
                </Await>
            </Suspense>
        </>
    );
}
